// extracted by mini-css-extract-plugin
export default {"container":"homeCover_container__6WlO5","abso":"homeCover_abso__apKUx","scrollIcon":"homeCover_scrollIcon__+v5UZ","blink":"homeCover_blink__JGtBn"};